import { type FC, useContext, useMemo } from 'react';
import { type NavigationItemsType } from '@common/types/components';
import cn from 'classnames';

import { useScratchLive } from '@/common/hooks/scratch-live';
import { useAppSelector } from '@/redux/store';

import { CompleteContractAnimationContext } from '../Animations/CompleteContractAnimation/context';

import { NavigationItem } from './NavigationItem/NavigationItem';
import { labelByItem } from './config';

import css from './styles.module.scss';

const ALL_NAV_ITEMS: NavigationItemsType[] = [
  'partners',
  'tickets',
  'arena',
  'rollCraft',
  'shop',
];

const Navigation: FC = () => {
  const userLevel = useAppSelector((state) => state.user.user?.level);
  const inviterId = useAppSelector((state) => state.user.user?.inviterId);
  const { animationStep } = useContext(CompleteContractAnimationContext);
  const scratch = useScratchLive();
  const visibleMap = useMemo(() => {
    const level = userLevel ?? 0;

    return {
      partners: !!inviterId || level >= 5,
      tickets: true,
      arena: true,
      rollCraft: level >= 3,
      shop: level >= 4,
    } satisfies Record<NavigationItemsType, boolean>;
  }, [userLevel, inviterId]);

  return (
    <nav className={css.navigation}>
      {ALL_NAV_ITEMS.map((name) => (
        <NavigationItem
          key={name}
          className={cn(
            'flex-1',
            !visibleMap[name] && 'pointer-events-none opacity-0 invisible',
          )}
          label={labelByItem[name]}
          name={name}
          animationStep={
            name === 'rollCraft' || name === 'tickets'
              ? animationStep
              : undefined
          }
          attention={
            name === 'rollCraft' && scratch.isUnseen ? 'glow' : undefined
          }
        />
      ))}
    </nav>
  );
};

export { Navigation };
